import { IconBuses, IconRideInterconnection, IconTimetable } from '@flixbus/honeycomb-icons-react';

import { formatSummaryDateTime } from 'utils/datetime/fnsTimeFormatter';

import { CREATE_BREAKDOWN_FLOW_TEXT } from '../texts';

const LABELS = CREATE_BREAKDOWN_FLOW_TEXT.summary.rowLabels;

/**
 * @typedef {import('./summarySectionsRegistry').SummaryRow} SummaryRow
 */

const formatStation = (station) => {
	if (!station?.code) return '';
	if (!station.name) return station.code;
	return `${station.code} (${station.name})`;
};

/**
 * Build the row list for the Summary "Parallel ride" accordion.
 *
 * @param {object} data
 * @returns {SummaryRow[]}
 */
export const deriveParallelRideRows = (data) => {
	const ride = data?.parallelRide;
	if (!ride) return [];

	const stations = ride.stations ?? [];
	const first = stations[0];
	const last = stations[stations.length - 1];

	return [
		{
			label: LABELS.tripLine,
			value: `TN ${ride.tripNumber ?? ''} / ${ride.lineCode ?? ''}`,
			icon: IconBuses,
		},
		{
			label: LABELS.route,
			value: `${formatStation(first)} → ${formatStation(last)}`,
			icon: IconRideInterconnection,
		},
		{
			label: LABELS.departure,
			value: formatSummaryDateTime(ride.departure),
			icon: IconTimetable,
		},
	];
};
